import script from "./QueueList.vue?vue&type=script&setup=true&lang=js"
export * from "./QueueList.vue?vue&type=script&setup=true&lang=js"

import "./QueueList.vue?vue&type=style&index=0&id=bdbcc6b0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bdbcc6b0"]])

export default __exports__